export default __webpack_public_path__ + "static/media/School Program - Class 10.a4550d1f.jpg";